var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeaderCampaign = function SvgIconHeaderCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M10 18.833c3.543 0 6.666-2.5 6.666-5.833s-2.5-5-3.333-5.833c-1.085-1.085-1.48-2.485-1.617-3.528-.092-.701-.774-1.194-1.347-.78-.942.68-2.168 1.97-2.87 4.308-.535 1.784 0 3.333 0 3.333s-.833-.417-1.25-1.667a36.391 36.391 0 0 0-.358-1.014c-.31-.845-1.447-.836-1.714.024-.42 1.354-.844 3.038-.844 4.324 0 4.166 3.123 6.666 6.667 6.666Z"
  })));
};
export default SvgIconHeaderCampaign;